export const NEW_MESSAGE_EVENT = 'new_message_event';
